var map = {
	"./chevron-left.svg": 630,
	"./chevron-right.svg": 631,
	"./facebook.svg": 632,
	"./instagram.svg": 633,
	"./loading.svg": 634,
	"./menu.svg": 635,
	"./spinner.svg": 636,
	"./trash.svg": 637,
	"./upload.svg": 638,
	"./xlsx-file.svg": 639,
	"./youtube.svg": 640
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1228;



//////////////////
// WEBPACK FOOTER
// ./src/images/icons ^\.\/.*\.svg$
// module id = 1228
// module chunks = 0